import React, { ReactNode, useState } from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import { StaticImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import * as styles from './Play.module.scss'
import Activity from '../activity/Activity'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

function unlerp (a: number, b: number, v: number) {
  return (v - a) / (b - a)
}

function lerp (a: number, b: number, u: number) {
  if (a <= b) {
    return a + (b - a) * u
  } else {
    return b + (a - b) * (1 - u)
  }
}

const ActivityCarousel = () => {
  const t = useIntl()

  return (
    <Slider
      dots={false}
      centerMode
      swipe
      slidesToShow={1}
      initialSlide={1}
      arrows={false}
      centerPadding='20px'
      variableWidth

    >
      <div className={styles.activity}>
        <Activity
          image={(
            <StaticImage
              width={297} height={216}
              src='./assets/activity-1.png' alt=''
            />
        )}
          caption={t.formatMessage({ id: 'play.activity1' })}
        />
      </div>
      <div className={styles.activity}>
        <Activity
          image={(
            <StaticImage
              width={297} height={216}
              src='./assets/activity-2.png' alt=''
            />
      )}
          caption={t.formatMessage({ id: 'play.activity2' })}
        />
      </div>
      <div className={styles.activity}>
        <Activity
          image={(
            <StaticImage
              width={297} height={216}
              src='./assets/activity-3.png' alt=''
            />
      )}
          caption={t.formatMessage({ id: 'play.activity3' })}
        />
      </div>
      <div className={styles.activity}>
        <Activity
          image={(
            <StaticImage
              width={297} height={216}
              src='./assets/activity-4.png' alt=''
            />
      )}
          caption={t.formatMessage({ id: 'play.activity4' })}
        />
      </div>
    </Slider>
  )
}
export default ActivityCarousel
